import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import SportTabSelectorImpl from './sport-tab-selector.js';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Tab selector for sport. Racing tabs: Highlights, Meetings & Future. Other sports tabs: Home, Competitions & Outrights.
 *
 * @class SportTabSelector
 * @memberof Mojito.Modules
 */

/**
 * SportTabSelector prop types.
 *
 * @property {object} routeParams - Navigation params.
 * @property {Function} [shouldExcludeTab = () => {}] - Callback to exclude the tab from rendering.
 * @property {Array<Mojito.Modules.SportTabSelector.types.TabDataItem>} tabs - Array pf tabs.
 *
 * @memberof Mojito.Modules.SportTabSelector
 */

const propTypes = {
    routeParams: PropTypes.object.isRequired,
    shouldExcludeTab: PropTypes.func,
    tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const defaultProps = {
    shouldExcludeTab: noop,
};

export default UIView('SportTabSelector', SportTabSelectorImpl, propTypes, defaultProps);
